import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import FunFact2 from '../../components/FunFact2/FunFact2';
import TeamSection from '../../components/TeamSection/TeamSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png';
import AboutImage from '../../images/angle.jpg';

const AboutPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-header-style-4'} Logo={Logo} />
            <PageTitle pageTitle={'À propos'} pagesub={'À propos'} />
            <About hclass={'wpo-about-area section-padding'} Ab={AboutImage} />
            <FunFact2 />
            <ServiceSection hclass={"wpo-service-area"} ServiceBtn={true} style={{ marginTop: '60px' }} />
     
            {/* <TeamSection hclass={'wpo-team-section section-padding'} SectionTitleShow={true} /> */}
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar /> 
        </Fragment>
    )
};
export default AboutPage;
